// aa-mj-sort-options.js
// Alphabetische Sortieroptionen (A–Z / Z–A) aus dem Sortier-Dropdown auf Kollektionsseiten entfernen.
// Einbindung in layout/theme.liquid vor </body>:
// → Diese Zeile einfügen:
// <script src="{{ 'aa-mj-sort-options.js' | asset_url }}" defer></script>
// Nach Theme-Update: Einbindung in theme.liquid prüfen – diese Datei bleibt erhalten.

document.addEventListener('DOMContentLoaded', function () {
  function removeAlphaSort() {
    document.querySelectorAll('option[value="title-ascending"], option[value="title-descending"]').forEach(function (el) {
      el.remove();
    });
  }
  removeAlphaSort();
});
